// Actions
import { ActionType } from "@ms/planner-actions/lib/local/ActionType";
/** A tuple of the supported ActionType values for TemplateStore, for use in the registry */ export const TemplateStoreActionTypes = [
    ActionType.CreateTemplateFromPlanFailedAction,
    ActionType.CreateTemplateFromPlanStartedAction,
    ActionType.CreateTemplateFromPlanSucceededAction,
    ActionType.CreateTemplateFromPlanValidationFailedAction,
    ActionType.ClearCreateTemplateFromPlanValidationFailedAction,
    ActionType.DeleteCustomTemplateSucceededAction,
    ActionType.FetchEntityCollectionAction,
    ActionType.FetchEntityCollectionFailedAction,
    ActionType.FetchEntityCollectionSucceededAction,
    ActionType.SearchPlanTemplateAction,
    ActionType.SearchPlanTemplateSucceededAction,
    ActionType.SearchPlanTemplateFailedAction
];
